// The catalogs, which languages read right to left, and which are fit to offer.
//
// One file per language, each a plain object keyed by the ENGLISH string. A key
// with no entry falls back to English, so a partly-translated catalog is a
// partly-translated screen rather than a broken one -- which is what makes it
// possible to add a language before every string is done.
//
// REVIEWED is the gate that matters. A translation nobody who speaks the
// language has read is a guess, and guessing at the words on a child-safety
// site is not a small risk: "report", "block", "you must be 18" are the
// strings where being subtly wrong does harm. So an unreviewed catalog is NOT
// offered in the picker and is never auto-selected from the browser's
// languages. It can still be loaded deliberately (?lang=es) to be read and
// corrected, which is how it gets reviewed.
//
// Adding a language: write the file, import it here, leave reviewed false until
// somebody who speaks it has been through it. locale-catalogs.test.mjs checks
// that every key in every catalog is a real English string in the app, so a
// stale key cannot rot quietly.

import es from './es.js';
import ar from './ar.js';
import tr from './tr.js';

/** @type {Record<string, { name: string, strings: object, reviewed: boolean }>} */
export const LANGUAGES = {
  en: { name: 'English', strings: {}, reviewed: true }, // the source: the key is the string
  es: { name: 'Espanol', strings: es, reviewed: false },
  ar: { name: 'Arabic', strings: ar, reviewed: false },
  tr: { name: 'Turkce', strings: tr, reviewed: false },
};

/** Just the strings, for the lookup path. */
export const CATALOGS = Object.fromEntries(Object.entries(LANGUAGES).map(([tag, l]) => [tag, l.strings]));

/** Primary subtags that are written right to left. */
export const RTL_LANGUAGES = new Set(['ar', 'he', 'fa', 'ur']);

/** What a picker should show, and what the browser's languages may select. */
export function offeredLanguages() {
  return Object.entries(LANGUAGES)
    .filter(([, l]) => l.reviewed)
    .map(([tag, l]) => ({ tag, name: l.name, rtl: RTL_LANGUAGES.has(tag) }));
}

export default { LANGUAGES, CATALOGS, RTL_LANGUAGES, offeredLanguages };
